import CreateITRQPayloadDTO from "@/dto/request/itrq/CreateITRQPayloadDTO";
import axios, { AxiosResponse } from "axios";
import { INDIVIDUAL_TAXATION_ENDPOINT, INDIVIDUAL_TAXATION_PUBLIC_ENDPOINT } from '@/constants/endpoints'
import authHeader from "@/services/auth-header";
import ITRQ_DTO from "@/dto/request/itrq/ITRQ_DTO";
import { ITRQDocumentType } from "@/constants/request/ITRQDocumentType";
import FileMetaDTO from "@/dto/files/FileMetaDTO";
import AuthFormPayload from "@/dto/archive/AuthFormPayload";
import ITRQFilter from "@/dto/request/itrq/ITRQFilter";
import ITRQShortDTO from "@/dto/request/itrq/ITRQShortDTO";
import UploadTaxReturnPayload from "@/dto/request/itrq/UploadTaxReturnPayload";
import TaxReturnFilter from "@/dto/payroll/TaxReturnFilter";
import IncomeTaxReturnDocumentDTO from "@/dto/payroll/IncomeTaxReturnDocumentDTO";
import Page from "@/dto/taxation/Page";
import CreateIndividualQuestionnaireRequestDTO from "@/dto/taxation/individual/CreateIndividualQuestionnaireRequestDTO";

class IndividualTaxationService {

    createQuestionnaire(payload: CreateITRQPayloadDTO | CreateIndividualQuestionnaireRequestDTO): Promise<AxiosResponse<ITRQ_DTO>> {
        let backendPayload: any;
        if ((payload as any).personFirstName || (payload as any).personId || (payload as any).email) {
            backendPayload = payload;
        } else {
            const p = payload as any;
            backendPayload = {
                year: parseInt(p.period || p.year),
                personId: p.customerId
            };
        }
        return axios.post(INDIVIDUAL_TAXATION_ENDPOINT, backendPayload, { headers: authHeader() });
    }

    getQuestionnaireByPublicId(publicId: string) {
        return axios.get<ITRQ_DTO>(`${INDIVIDUAL_TAXATION_PUBLIC_ENDPOINT}/${publicId}`);
    }

    updateQuestionnaireByPublicId(publicId: string, payload: ITRQ_DTO) {
        return axios.put(`${INDIVIDUAL_TAXATION_PUBLIC_ENDPOINT}/${publicId}`, payload);
    }

    saveDocumentByPublicId(publicId: string, documentType: ITRQDocumentType, file: FileMetaDTO) {
        return axios.put(`${INDIVIDUAL_TAXATION_PUBLIC_ENDPOINT}/${publicId}/${documentType}`, file)
    }

    getById(id: number) {
        return axios.get<ITRQ_DTO>(`${INDIVIDUAL_TAXATION_ENDPOINT}/${id}`, { headers: authHeader() });
    }

    saveById(id: number, payload: ITRQ_DTO) {
        return axios.put(`${INDIVIDUAL_TAXATION_ENDPOINT}/${id}`, payload, { headers: authHeader() });
    }

    batch() {
        return axios.put(`${INDIVIDUAL_TAXATION_ENDPOINT}/batch/2025`, {}, { headers: authHeader() });
    }

    sendAuthForm(id: number, payload: AuthFormPayload) {
        return axios.post(`${INDIVIDUAL_TAXATION_ENDPOINT}/${id}/auth`, payload, { headers: authHeader() });
    }

    getQuestionnaires(filter: ITRQFilter) {
        return axios.get<Page<ITRQShortDTO>>(`${INDIVIDUAL_TAXATION_ENDPOINT}/questionnaires`, { params: filter, headers: authHeader() });
    }

    uploadTaxReturn(id: number, payload: UploadTaxReturnPayload) {
        return axios.post(`${INDIVIDUAL_TAXATION_ENDPOINT}/${id}/returns`, payload, { headers: authHeader() });
    }

    setSubmissionId(id: number, returnId: number, submissionId: string) {
        return axios.post(`${INDIVIDUAL_TAXATION_ENDPOINT}/${id}/returns/${returnId}/submission-id`, { submissionId }, { headers: authHeader() });
    }

    getTaxReturns(filter: TaxReturnFilter): Promise<AxiosResponse<Page<IncomeTaxReturnDocumentDTO>>> {
        return axios.get(`${INDIVIDUAL_TAXATION_ENDPOINT}/returns`, { params: filter, headers: authHeader() });
    }
}

export default new IndividualTaxationService();